import Signup from 'src/utils/navigator/living-with-high-blood-pressure/sign-up';
import Week1 from 'src/utils/navigator/living-with-high-blood-pressure/week-1';
import Week2 from 'src/utils/navigator/living-with-high-blood-pressure/week-2';
import Week3 from 'src/utils/navigator/living-with-high-blood-pressure/week-3';
import Week4 from 'src/utils/navigator/living-with-high-blood-pressure/week-4';
import Week5 from 'src/utils/navigator/living-with-high-blood-pressure/week-5';
import Week6 from 'src/utils/navigator/living-with-high-blood-pressure/week-6';
import Week7 from 'src/utils/navigator/living-with-high-blood-pressure/week-7';
import Week8 from 'src/utils/navigator/living-with-high-blood-pressure/week-8';
import Week9 from 'src/utils/navigator/living-with-high-blood-pressure/week-9';
import Week10 from 'src/utils/navigator/living-with-high-blood-pressure/week-10';
import Week11 from 'src/utils/navigator/living-with-high-blood-pressure/week-11';
import Week12 from 'src/utils/navigator/living-with-high-blood-pressure/week-12';

import config from 'config/config';

const NAVIGATOR_URL = `${config.cdn.navigator}living-with-high-blood-pressure/`;
const bannerImage = `${NAVIGATOR_URL}banner.jpg`;
const brandLogo = `${NAVIGATOR_URL}logo.jpg`;
const title = 'Living with high blood pressure';

const weeks = {
  'sign-up': Signup,
  '1': Week1,
  '2': Week2,
  '3': Week3,
  '4': Week4,
  '5': Week5,
  '6': Week6,
  '7': Week7,
  '8': Week8,
  '9': Week9,
  '10': Week10,
  '11': Week11,
  '12': Week12,
};

const getPage = (selectedWeek, personalisation) => {
  const week = weeks[selectedWeek] || weeks['sign-up'];
  return week.getPage(personalisation);
};
const getMenu = (selectedWeek, personalisation) => {
  const week = weeks[selectedWeek] || weeks['sign-up'];
  return week.getMenu(personalisation);
};
const getFooter = selectedWeek => {
  const week = weeks[selectedWeek] || weeks['sign-up'];
  return week.Footer;
};

const obj = {
  getPage,
  getMenu,
  getFooter,
  brandLogo,
  bannerImage,
  title,
  getSeoTitle: 'Living with high blood pressure | HealthUnlocked',
};

export default obj;
